module.exports = __webpack_public_path__ + "img/left.c2daa050.png";